import React from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import IndigentLayout from '../layout/IndigentLayout';
import SimpleLayout from '../layout/SimpleLayout';
import CreateIndigentPage from '../pages/CreateIndigentPage';
import EditIndigentPage from '../pages/EditIndigentPage';
import Approval from '../modules/Approval';
import UserPage from '../pages/UserPage';
import AddUserPage from '../modules/User/AddUserPage';
import MyAccountPage from '../pages/MyAccountPage';
import HomePage from '../pages/HomePage';
import IndigentDashboard from '../pages/IndigentDashboard';
import LogBookPage from '../pages/LogBookPage';
import Dashboard from '../modules/Reports/Dashboard';
import ITUserAction from '../modules/UserAction/ITUserAction';
import UserActionCard from '../modules/UserAction/UserAction';
import ProtectedRoute from '../components/ProtectedRoute';
import LoginPage from '../pages/LoginPage';
import PasswordResetPage from '../pages/PasswordResetPage';
import RequestPasswordPage from '../pages/RequestPasswordPage';
import VerificationSystem from '@/pages/verificationSystem';
import BusinessOnlineEnquiry from '../pages/verificationSystemPages/BusinessOnlineEnquiry';
import AccountVerificationService from '../pages/verificationSystemPages/AccountVerificationService';
import CIPCReport from '../pages/verificationSystemPages/CIPCReport';
import ConsumerTrace from '../pages/verificationSystemPages/ConsumerTrace';
import DeedsEnquiry from '../pages/verificationSystemPages/DeedsEnquiry';
import DigitalOnboardingVerificationSystem from '../pages/verificationSystemPages/DigitalOnboardingVerificationSystem';
import DirectorEnquiryReport from '../pages/verificationSystemPages/DirectorEnquiryReport';
import FaceviewPlus from '../pages/verificationSystemPages/FaceviewPlus';
import KYCOnline from '../pages/verificationSystemPages/KYCOnline';
import RealtimeIDVerification from '../pages/verificationSystemPages/RealtimeIDVerification';
import RealtimeMarriageVerification from '../pages/verificationSystemPages/RealtimeMarriageVerification';
import RealtimeIDV from '../pages/verificationSystemPages/RealtimeIDV';
import TelephoneTrace from '../pages/verificationSystemPages/TelephoneTrace';
import VerificationHistory from '../pages/verificationSystemPages/VerificationHistory';

const AppRoutes: React.FC = () => (
    <Routes>
        {/* Public routes */}
        <Route path='/login' element={<LoginPage />} />
        <Route path='/request-password' element={<RequestPasswordPage />} />
        <Route path='/password/reset' element={<PasswordResetPage />} />

        {/* Home page - SimpleLayout (TopBar only) */}
        <Route
            path='/'
            element={
                <ProtectedRoute>
                    <SimpleLayout>
                        <HomePage />
                    </SimpleLayout>
                </ProtectedRoute>
            }
        />

        {/* Independent pages - SimpleLayout (TopBar only) */}
        <Route
            element={
                <ProtectedRoute>
                    <SimpleLayout>
                        <Outlet />
                    </SimpleLayout>
                </ProtectedRoute>
            }
        >
            <Route path='/my-account' element={<MyAccountPage />} />
        </Route>

        {/* Indigent module pages - IndigentLayout (TopBar + Sidebar) */}
        <Route
            element={
                <ProtectedRoute>
                    <IndigentLayout>
                        <Outlet />
                    </IndigentLayout>
                </ProtectedRoute>
            }
        >
            <Route path='/indigent-dashboard' element={<IndigentDashboard />} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='/add' element={<CreateIndigentPage />} />
            <Route path='/edit/:requestId' element={<EditIndigentPage />} />
            <Route path='/user-action' element={<UserActionCard />} />
            <Route path='/approval' element={<Approval />} />
            <Route path='/users' element={<UserPage />} />
            <Route path='/add-user' element={<AddUserPage />} />
            <Route path='/edit-user/:userId' element={<AddUserPage />} />
            <Route path='/reports/indigent-register' element={<LogBookPage />} />
            <Route path='/reports/dashboard' element={<Dashboard />} />
            <Route path='/it-user-action' element={<ITUserAction />} />

            {/* Verification system routes */}
            <Route path='/verification/dashboard' element={<VerificationSystem />} />
            <Route path='/verification/business-online-enquiry' element={<BusinessOnlineEnquiry />} />
            <Route path='/verification/account-verification-service' element={<AccountVerificationService />} />
            <Route path='/verification/cipc-report' element={<CIPCReport />} />
            <Route path='/verification/consumer-trace' element={<ConsumerTrace />} />
            <Route path='/verification/deeds-enquiry' element={<DeedsEnquiry />} />
            <Route path='/verification/digital-onboarding-verification-system' element={<DigitalOnboardingVerificationSystem />} />
            <Route path='/verification/director-enquiry-report' element={<DirectorEnquiryReport />} />
            <Route path='/verification/faceview-plus' element={<FaceviewPlus />} />
            <Route path='/verification/kyc-online' element={<KYCOnline />} />
            <Route path='/verification/realtime-id-verification' element={<RealtimeIDVerification />} />
            <Route path='/verification/realtime-marriage-verification' element={<RealtimeMarriageVerification />} />
            <Route path='/verification/realtime-idv' element={<RealtimeIDV />} />
            <Route path='/verification/telephone-trace' element={<TelephoneTrace />} />
            <Route path='/verification/history' element={<VerificationHistory />} />
        </Route>

        {/* Redirect all other routes to home */}
        <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
);

export default AppRoutes;